import { FC } from 'react';

const StarIcon: FC<{ size?: number; className?: string }> = ({ size = 24, className = '' }) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className={className}
		aria-hidden="true"
	>
		<path
			d="M14.3496 9.3252L14.4678 9.60254L14.7676 9.62793L20.7764 10.1377L16.2129 14.0918L15.9844 14.29L16.0527 14.584L17.4238 20.46L12.2588 17.3418L12 17.1855L11.7412 17.3418L6.5752 20.46L7.94727 14.584L8.01562 14.29L7.78711 14.0918L3.22266 10.1377L9.23242 9.62793L9.53223 9.60254L9.65039 9.3252L12 3.78027L14.3496 9.3252Z"
			fill="#FFD96A"
			stroke="#806310"
		/>
	</svg>
);

export default StarIcon;
